import emptyDateObject from './emptyDateObject';
import dateToObject from './dateToObject';
import { DateObject } from '../questionnaireHelpers';

export default function dateStringToObject(dateString: string | null): DateObject {
	if (dateString) {
		return dateToObject(new Date(dateString));
	}

	return emptyDateObject;
}
